var map = {
	"./dashboard/chrome.png": 800,
	"./dashboard/contact-icon.png": 801,
	"./dashboard/download.png": 802,
	"./dashboard/files-icon.png": 803,
	"./dashboard/firefox.png": 804,
	"./dashboard/gallery.jpg": 805,
	"./dashboard/gallery.png": 806,
	"./dashboard/ie.png": 807,
	"./dashboard/light.jpg": 808,
	"./dashboard/light.png": 809,
	"./dashboard/mouse-icon-sm.png": 810,
	"./dashboard/mouse-icon.png": 811,
	"./dashboard/project-icon.png": 812,
	"./dashboard/rich-icon-sm.png": 813,
	"./dashboard/rich-icon.png": 814,
	"./dashboard/safari.png": 815,
	"./dashboard/shopping-bag-icon-sm.png": 816,
	"./dashboard/shopping-bag-icon.png": 817,
	"./dashboard/tasks-icon.png": 818,
	"./dashboard/teams-icon.png": 819,
	"./error.png": 820,
	"./favicon-32x32.png": 821,
	"./favicon.ico": 822,
	"./logo copy.png": 823,
	"./logo.png": 132,
	"./marker.png": 824,
	"./menu-icon.png": 825,
	"./odoc-logo.png": 826,
	"./pentagon.png": 827,
	"./pentagon_1.png": 828,
	"./placeholder.jpg": 829,
	"./verify-success.svg": 830,
	"./widget/birds.png": 831,
	"./widget/bread.png": 832,
	"./widget/building.png": 833,
	"./widget/disc.png": 834,
	"./widget/flying.png": 835,
	"./widget/glass.png": 836,
	"./widget/noodles.png": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;